import React, { useCallback, useMemo } from 'react'
import MultiLocationForm from './Components/MultiLocationForm'
import MultiLocationList from './Components/MultiLocationList'
import MappingHeader from '../Shared/Components/MappingHeader'
import StatusBanner from '../Shared/Components/StatusBanner'
import useMultiLocationMapping, { isRowComplete } from './useMultiLocationMapping'
import Shared from '../Shared/mappingUi.module.css'

const MultiLocationMapping = ({ connectorId, instancesId, targetId }) => {
    const {
        erpLocations,
        ecommerceLocations,
        rows,
        isLoading,
        loadError,
        isSaving,
        saveStatus,
        addRow,
        updateRow,
        removeRow,
        submitMappings,
        dismissStatus
    } = useMultiLocationMapping(connectorId, instancesId, targetId)

    const completeRowCount = useMemo(() => rows.filter(isRowComplete).length, [rows])
    const hasIncompleteRow = completeRowCount !== rows.length

    const isDuplicatePair = useCallback(
        (erpLocationId, ecommerceLocationId) => rows.some(
            (row) => row.erpLocationId === erpLocationId && row.ecommerceLocationId === ecommerceLocationId
        ),
        [rows]
    )

    const isBusy = isLoading || isSaving

    return (
        <>
            <MappingHeader
                title="Multi Location Mapping"
                countLabel={!isLoading && !loadError ? `${completeRowCount} mapped` : ''}
                isSaving={isSaving}
                isDisabled={isLoading || Boolean(loadError)}
                onSubmit={submitMappings}
            />

            <div className={`card-body p-10 ${Shared.body}`}>
                <StatusBanner status={saveStatus} onDismiss={dismissStatus} />

                <MultiLocationForm
                    erpLocations={erpLocations}
                    ecommerceLocations={ecommerceLocations}
                    isDisabled={isBusy || Boolean(loadError)}
                    isDuplicate={isDuplicatePair}
                    onAdd={addRow}
                />

                {hasIncompleteRow ? (
                    <p className={Shared.hint}>
                        <i className="uil-info-circle" aria-hidden="true" />
                        {' '}Rows with an empty location are skipped when you submit.
                    </p>
                ) : null}

                <MultiLocationList
                    rows={rows}
                    erpLocations={erpLocations}
                    ecommerceLocations={ecommerceLocations}
                    isLoading={isLoading}
                    loadError={loadError}
                    isDisabled={isSaving}
                    onChange={updateRow}
                    onRemove={removeRow}
                />
            </div>
        </>
    )
}

export default MultiLocationMapping
